module.exports = __webpack_public_path__ + "static/media/uniswap-logo.a84383f8.png";